import styled, { css, createGlobalStyle } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

const toastCss = css `
  .tend-ui-notification
    .tend-ui-notification-notice
    .tend-ui-notification-notice-with-icon {
    .tend-ui-notification-notice-message {
      margin-inline-start: 52px;
      margin-bottom: 0;
    }

    .tend-ui-notification-notice-description {
      margin-inline-start: 52px;
      min-height: 12px;
    }
  }

  /* Workaround for Chrome animation flickering */
  .tend-ui-notification-stack > .tend-ui-notification-notice-wrapper {
    transition: all 0.3s, backdrop-filter 0s, opacity 0s;
  }

  .tend-ui-notification .tend-ui-notification-notice {
    .tend-ui-notification-notice-close {
      inset-inline-end: 12px;
    }

    .tend-ui-notification-notice-icon {
      padding: 8px;
      border-radius: 8px;
    }

    /* Success, error, warning, info */
    &:not(.tend-ui-notification-notice-neutral) .tend-ui-notification-notice-icon {
      &.tend-ui-notification-notice-icon-success {
        background: rgba(77, 208, 131, 0.15);
      }
      &.tend-ui-notification-notice-icon-error {
        background: rgba(240, 75, 105, 0.15);
      }
      &.tend-ui-notification-notice-icon-warning {
        background: rgba(250, 173, 20, 0.15);
      }
      &.tend-ui-notification-notice-icon-info {
        background: rgba(0, 123, 251, 0.15);
      }
    }

    /* Neutral icon */
    &.tend-ui-notification-notice-neutral .tend-ui-notification-notice-icon {
      &.tend-ui-notification-notice-icon-info {
        color: ${colors.gray400};
        background: rgba(165, 167, 175, 0.15);
      }
    }

    &.tend-ui-notification-notice-loading .tend-ui-notification-notice-icon {
      color: ${colors.gray400};
      background: rgba(165, 167, 175, 0.15);
    }
  }
`;
const Styles = createGlobalStyle `${toastCss}`;
const Footer = styled.div `
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 12px;
`;

export { Footer, Styles };
//# sourceMappingURL=styled.js.map
